<template>
  <div>
    <div class="row">
      <div class="col-xl-9"><h5 class="mb-7">Vidéos</h5></div>
      <div class="col-xl-3 text-end">
        <a class="btn btn-primary" @click.stop="dialog = true">
          Ajouter une vidéo
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-group">
          <v-simple-table class="elevation-2">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Nom des vidéos dans ce parcours</th>
                </tr>
              </thead>
              <draggable
                  tag="tbody"
                  v-model="course.videos"
                  @start="dragging = true"
                  @end="onEnd"
              >
                <tr v-for="video in course.videos" :key="video.id">
                  <td>
                    <div class="d-flex justify-content-between align-items-center">
                      <div>{{ video.title }}</div>
                      <div>
                        <v-btn color="transparent" text @click="removeVideo(video)">
                          <div class="fa fa-trash" style="color: #e6007e"></div>
                        </v-btn>
                      </div>
                    </div>
                  </td>
                </tr>
              </draggable>
            </template>
          </v-simple-table>
        </div>
      </div>
    </div>
    <!-- DIALOG AJOUT VIDEO -->
    <v-dialog v-model="dialog" max-width="590">
      <v-card>
        <v-card-title class="headline">
          Veuillez sélectionner une vidéo à ajouter au parcours
        </v-card-title>

        <v-card-text>
          <v-combobox
            v-model="model"
            :items="items"
            :loading="isLoading"
            :search-input.sync="search"
            hide-no-data
            hide-selected
            item-text="title"
            item-value="@id"
            label="Bibliothèque de vidéos"
            placeholder="Commencer à taper un titre pour rechercher ... "
            prepend-icon="mdi-database-search"
            return-object
          ></v-combobox>
        </v-card-text>

        <v-divider></v-divider>

        <v-expand-transition>
          <div v-if="model !== null">
            <video controls width="400">
              <source :src="apiUrl + model.videoPath" type="video/mp4" />

              Sorry, your browser doesn't support embedded videos.
            </video>
            <p>Description de la vidéo : {{ model.description }}</p>
            <p>Thème de la vidéo : {{ model.theme.title }}</p>
          </div>
        </v-expand-transition>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="orange darken-1" text @click="dialog = false">
            Annuler
          </v-btn>

          <v-btn color="blue darken-1" text @click="addVideo"> Ajouter </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/core/services/api.service";
import draggable from "vuedraggable";

export default {
  model: {
    prop: "course",
    event: "input",
  },
  props: {
    course: Object,
  },
  components:{
    draggable
  },
  data: () => ({
    dialog: false,
    descriptionLimit: 60,
    videos: [],
    isLoading: false,
    model: null,
    search: null,
    dragging: false,
  }),

  computed: {
    apiUrl() {
      return process.env.VUE_APP_API;
    },
    items() {
      return this.videos.map((video) => {
        const title =
          video.title.length > this.descriptionLimit
            ? video.title.slice(0, this.descriptionLimit) + "..."
            : video.title;

        return Object.assign({}, video, { title });
      });
    },
  },
  watch: {
    search(value) {
      // Items have already been loaded
      //if (this.items.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = true;

      // Lazily load input items
      Api.query("videos", { params: { title: value } })
        .then((res) => {
          const videos = res.data["hydra:member"];
          this.videos = videos;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
  },
  methods: {
    addVideo() {
      this.$emit("addVideo", this.model);
      this.dialog = false;
      this.model = null;
    },
    removeVideo(video) {
      if (confirm("Are you sure you want to delete this item?")) {
        this.isLoading = true;
        Api.patch("courses", this.course.id, {
          videos: this.course.videos
            .filter((v) => v.id !== video.id)
            .map((v) => v["@id"]),
        })
          .then(() => {
            this.$emit("removeVideo", video);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => (this.isLoading = false));
      }
    },
    onEnd() {
      this.dragging = false;
      this.course.videos = this.course.videos.map((v, index) => {
        v.position = index;
        return v;
      });
      return true;
    },
  },
};
</script>
